import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { BaseInfoCardProps } from '..'
import { useIsMobile } from 'hooks/useIsMobile'
// import { useHandlerUrls } from 'hooks/useHandlerUrls'

export type VerticalLayoutInfoCardProps = {
  ratio?: number
} & BaseInfoCardProps &
  BoxProps

export const VerticalLayout = (props: VerticalLayoutInfoCardProps) => {
  const {
    title,
    description,
    thumbnail,
    ratio = 430 / 380,
    url = '',
    className,
    classNames,
    styles,
    ...rest
  } = props
  const { classes, cx } = useStyles(undefined, {
    name: 'InfoCard--VerticalLayout',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  // const linkData = useHandlerUrls([url])
  // const { isExternalUrl } = linkData?.[0] || {}
  return (
    <Box
      className={cx(className, classes.root)}
      {...(url &&
        isMobile && {
          component: 'a' as any,
          href: url,
          // target: isExternalUrl ? '_blank' : '_self',
          target: '_blank',
        })}
      {...rest}
    >
      <AspectRatio ratio={ratio} className={classes.thumbnail}>
        <img
          loading="lazy"
          src={thumbnail}
          alt={title}
          className={classes.img}
        />
      </AspectRatio>
      <AspectRatio ratio={429 / 380} className={classes.bg}>
        <img
          loading="lazy"
          src={CommonGAssets.getAssetPath('appIntro/blue-blur-bg.jpg')}
          alt=""
        />
      </AspectRatio>
      <Box className={classes.info}>
        {title && <Text size={isMobile ? 's1' : 's2'}>{title}</Text>}
        {description && (
          <Text
            size={isMobile ? 'p2' : 'p1'}
            as="div"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </Box>
    </Box>
  )
}
